interface CheckMarkIconProps {
  className?: string;
  onClick?: () => void;
}

const CheckMarkIcon = (props: CheckMarkIconProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 20 20"
      className={`${props.className ? props.className : ""} cursor-pointer`}
      fill="currentColor"
    >
      <path d="m0 11 2-2 5 5L18 3l2 2L7 18z" />
    </svg>
  );
};

export default CheckMarkIcon;
